import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { SearchActeBottomPanel } from './SearchActeBottomPanel.component'

const withUnmountHoc = withUnmountTransition(SearchActeBottomPanel)
export { withUnmountHoc as SearchActeBottomPanel }
